import { Stack } from "@mui/material";
import useDisplayDiets from "mt-components/hooks/useDisplayDiets";
import { noElement } from "mt-shared/collections";
import { useMemo } from "react";
import { DietaryRestriction } from "../../../../../__generated__/graphql";
import { default as AllergensList } from "./AllergensList";
import { default as DietsTable } from "./DietsTable";

type DietaryRestrictionsProps = {
  dietaryRestrictions: DietaryRestriction[];
};
export default function DietaryRestrictions({
  dietaryRestrictions,
}: DietaryRestrictionsProps) {
  const { includedAllergens, sortedDiets } = useDisplayDiets({
    dietaryRestrictions,
  });

  const hasAllergens = useMemo(
    () => !noElement(includedAllergens),
    [includedAllergens]
  );
  const hasDiets = useMemo(() => !noElement(sortedDiets), [sortedDiets]);

  return (
    <Stack flexDirection="row" gap={"4rem"}>
      {hasDiets && <DietsTable diets={sortedDiets} />}
      {hasAllergens && <AllergensList allergens={includedAllergens} />}
    </Stack>
  );
}
